import styled from "styled-components";
import {LobbyHeaderTitleDefaultBox} from "./lobby-header-title.default.box";

export const LobbyHeaderTitleMrGreenBox = styled(LobbyHeaderTitleDefaultBox)`
    margin-bottom: 1rem;
    font-size: 16px;
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        font-size: 1.4rem;
        &:first-of-type {
            margin-top: 0.9rem;
        }
        margin-bottom: 1.9rem;
    }
`;
